/**
 * event
 * Created by john
 * Date: 2019-08-02
 * Email: maiqingqiang@gmail.com
 * Time: 16:24
 */
import EventEmitter from 'events';

export default new EventEmitter();